import DocumentTemplate from "./DocumentTemplate";

export default DocumentTemplate;



// WEBPACK FOOTER //
// ./src/components/Template/index.js